import { render, staticRenderFns } from "./VerticalCoverMobileMockup.vue?vue&type=template&id=fe3965d8&"
import script from "./VerticalCoverMobileMockup.vue?vue&type=script&lang=js&"
export * from "./VerticalCoverMobileMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports